export const actionTypes: any = {
  // get appointment status
  GET_APPOINTMENT_STATUS_START: 'GET_APPOINTMENT_STATUS_START',
  GET_APPOINTMENT_STATUS_SUCCESS: 'GET_APPOINTMENT_STATUS_SUCCESS',
  GET_APPOINTMENT_STATUS_FINISH: 'GET_APPOINTMENT_STATUS_FINISH',
}
